import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ContactsTable, RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-add-contact',
	templateUrl: './add-contact.component.html',
	styleUrls: ['./add-contact.component.scss'],
})
export class AddContactComponent implements OnInit {
	@Input() carrierid;
	@Input() isEdit = false;
	@Input() contact: ContactsTable = null;
	@Output() contactAdded: EventEmitter<any> = new EventEmitter();

	constructor(public dialog: MatDialog, public utilService: UtilService) {}

	ngOnInit() {}

	openAddContactForm(): void {
		const dialogRef = this.dialog.open(AddContactFormDialog, {
			width: '650px',
			data: {
				carrierid: this.carrierid,
				isEdit: this.isEdit,
				contact: this.contact,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				this.contactAdded.emit(result);
			}
		});
	}
}

@Component({
	selector: 'app-add-contact-form-dialog',
	templateUrl: 'modal.template.html',
})
export class AddContactFormDialog implements OnInit {
	addContact: UntypedFormGroup;
	isRequestInProgress = false;
	contactId: String;

	model = {};

	constructor(
		public dialogRef: MatDialogRef<AddContactFormDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		private _formBuilder: UntypedFormBuilder,
		public utilService: UtilService
	) {
		this.addContact = this._formBuilder.group({
			firstName: ['', Validators.required],
			lastName: [''],
			email: ['', [Validators.required, Validators.email]],
			phoneNumber: '',
			mobileNumber: [''],
			mailReceiver: [false],
			primaryContact: [false],
			carrierId: this.data.carrierid,
			ext: '',
		});
	}

	ngOnInit() {
		if (this.data.isEdit) {
			const vm = this;
			this.addContact.controls['firstName'].setValue(this.data.contact.firstName);
			this.addContact.controls['lastName'].setValue(this.data.contact.lastName);
			this.addContact.controls['email'].setValue(this.data.contact.email);
			this.addContact.controls['mobileNumber'].setValue(this.data.contact.mobileNumber);
			this.addContact.controls['mailReceiver'].setValue(this.data.contact.isMailReciever);
			this.addContact.controls['primaryContact'].setValue(this.data.contact.primaryContact);
			this.addContact.controls['phoneNumber'].setValue(
				this.getPhoneNumber(this.data.contact.phoneNumber)
			);
			this.addContact.controls['ext'].setValue(this.getExtNumber(this.data.contact.phoneNumber));
			this.contactId = this.data.contact.contactId;
		}
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	onSubmit() {
		if (this.addContact.valid) {
			this.isRequestInProgress = true;
			const url = this.urlService.contactCreateUrl(this.data.carrierid);
			let payload = Object.assign({}, { ...this.addContact.value, contactId: this.contactId });
			if (!this.utilService.isNullOrUndefined(payload.ext) && payload.ext.length > 0) {
				payload.phoneNumber = payload.phoneNumber + ' ext.' + payload.ext;
				delete payload.ext;
			}
			this.restService.POST(url, payload).subscribe(
				(result) => {
					let message = `Contact ${this.data.isEdit ? 'updated' : 'added'} successfully.`;
					if (result.mappedCarriers && result.mappedCarriers > 0 && !this.data.isEdit) {
						this.utilService.showSnackbar(
							`Contact was already mapped with ${result.mappedCarriers} more carrier(s). ${message}`,
							SNACKBAR.WARNING,
							SNACKBAR.ACTION
						);
					} else {
						this.utilService.showSnackbar(message, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
					}
					this.isRequestInProgress = false;
					this.dialogRef.close(result);
				},
				(error) => {
					const invalidEmail = 'Email address is not valid';
					let errorMsg = `Unable to ${
						this.data.isEdit ? 'update' : 'add'
					} contact now. Invalid or duplicate contact email.`;
					if (error?.error && error?.error === invalidEmail) {
						errorMsg = invalidEmail;
					}
					console.log('error: ', error);
					this.utilService.showSnackbar(errorMsg, SNACKBAR.ERROR, SNACKBAR.ACTION);
					this.isRequestInProgress = false;
				}
			);
		}
	}

	getExtNumber(extNumber) {
		if (!this.utilService.isNullOrUndefined(extNumber)) {
			const numArray = extNumber.split('ext.');
			if (!this.utilService.isNullOrUndefined(numArray[1]) && numArray.length >= 1) {
				return numArray[1].trim();
			}
			return '';
		}
	}

	getPhoneNumber(phone) {
		if (!this.utilService.isNullOrUndefined(phone)) {
			var numArray = phone.split('ext.');
			return numArray[0].trim();
		}
	}
}
